import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../../components/mensajes2';
import useTable from "../../components/useTable";
import { Dimmer} from "../../components/spinner";
import { ModalRetenciones } from './modalAgregarRetencion';
import { Toasts } from '../toasts';
import { Input } from '../../ui/inputs/Input';
import { PrimaryButton } from '../../ui/buttons/Button';

const TablaTipoRetenciones = (props) => {
    var op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'))
    const txtId = useRef();
    const txtDescripcion = useRef();
    const cmbTipo = useRef();
    const txtDeducible = useRef();
    const chkPorcen = useRef();
    const chkMilPorcen = useRef();
    const chkUniTri = useRef();
    const chkMontFij = useRef();
    const chkOtroPor = useRef();
    const txtOtroPorcen = useRef();
    const txtIdProve = useRef();
    const txtIdCuenta = useRef();
    const txtCuentaCont = useRef();
    const txtIdCuenta2 = useRef();
    const txtCuentaCont2 = useRef();
    const txtBuscador = useRef();
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })
    const [operacion, setOperacion] = useState(0);
    const [mostrar, setMostrar] = useState(false);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [idReten, setIdReten] = useState(0)
    const [visibleBtn, setVisibleBtn] = useState('visible')
    const [visibleOtro, setVisibleOtro] = useState('collapse')
    const [visibleISLR, setVisibleISLR] = useState('hidden')
    const [tituloHeader, setTituloHeader] = useState('Gestionar Tipo de Retenciones.')
    const [records, setRecords] = useState([]);
    const permiso = JSON.parse(localStorage.getItem('acctiporetencion')) === null ? "0000" : JSON.parse(localStorage.getItem('acctiporetencion'));
    const [habilitado, setHabilitado] = useState(true);
    const [tercero, setTercero] = useState({
        idagente: '',
        nombre: ''
    }
    )
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [botones, setBotones] = useState({
        incluir: false,
        consultar: false,
        modificar: false,
        eliminar: false,
        aceptar: true,
        cancelar: true,
        catalogo: true,
        catalogoBene: true
    });
    const [values, setValues] = useState({
        idtiporetencion: '',
        descripcion: '',
        unidad: '',
        idcuentacontable: '',
        tipo: '',
        deducible: '',
        otro: '',
        idagente: '',
    });
    const headCells = [
        { id: 'codigo', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' },
        { id: 'descripcion', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
        { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
    ]
    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);
    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "")
                    return items;
                else
                    return items.filter(x => {
                        if ((x.idtiporetencion.toLowerCase().includes(target.value.toLowerCase()))
                            || (x.descripcion !== '' ? x.descripcion.toLowerCase().includes(target.value.toLowerCase()) : '')
                        ) {
                            return x;
                        }
                    });
            }
        })
    }
    const [habilitadoNU, setHabilitadoNU] = useState(true);
    const [operacionPer, setOperacionPer] = useState(0);
    const cerrarToast = () => {
        setToast({
            ...toast,
            mostrar: false
        })
    }
    const blanquear = () => {
        setOperacion('');
        txtIdCuenta.current.value = ''
        txtIdCuenta2.current.value = ''
        txtCuentaCont.current.value = ''
        txtCuentaCont2.current.value = ''
        txtIdProve.current.value = ''
        setTercero({
            idagente: '',
            nombre: ''
        })
        setTituloHeader('Gestionar Tipo de Retenciones.');
        chkPorcen.current.checked = false;
        chkMilPorcen.current.checked = false;
        chkUniTri.current.checked = false;
        chkMontFij.current.checked = false;
        chkOtroPor.current.checked = false;
        txtDeducible.current.value = '';
        txtOtroPorcen.current.value = '';
        setVisibleISLR('hidden')
        setVisibleOtro('collapse')
        setVisibleBtn('visible')
        setValues({
            idtiporetencion: '',
            descripcion: '',
            unidad: '',
            idcuentacontable: '',
            tipo: '',
            deducible: '',
            otro: '',
            idagente: '',
        })
        setBotones({
            incluir: false,
            consultar: false,
            modificar: false,
            eliminar: false,
            aceptar: true,
            cancelar: true,
            catalogo: true,
            catalogoBene: true
        });
        cmbTipo.current.value = '';
        txtId.current.value = '';
        txtDescripcion.current.value = '';
        setActivate(false);
        setOperacionPer(0);
        setHabilitado(true);
        setHabilitadoNU(true);
    }
    const procesarRegistro = () => {
        setActivate(true);
        let ope = 0;
        if (!botones.incluir) {
            ope = 1;
        } else if (!botones.modificar) {
            ope = 2;
        } else if (!botones.eliminar) {
            ope = 3;
        }
        let endpoint = `${op.conexion}/api/administracion/actualizartipRetencion`;
        let body;
        body = {
            operacion: ope,
            nid: values.idtiporetencion === '' ? 0 : values.idtiporetencion,
            descr: values.descripcion.toUpperCase().trim(),
            ip: parseInt(values.unidad),
            idprove: txtIdProve.current.value,
            plan: parseInt(values.tipo),
            dedu: txtDeducible.current.value === '' ? 0.00 : parseFloat(txtDeducible.current.value.replace(/\./g, '').replace(',', '.')),
            idcta: txtIdCuenta.current.value,
            idctater: txtIdCuenta2.current.value,
            efis: idefiscal,
            otr: txtOtroPorcen.current.value === '' ? 0.00 : parseFloat(txtOtroPorcen.current.value.replace(/\./g, '').replace(',', '.'))
        }
        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {
            if (response.status === 200) {
                if (ope === 1) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
                } else if (ope === 2) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
                } else if (ope === 3) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
                }
                blanquear()
                setActivate(false);
            }
        }).catch(function (error) {
            console.log(error)
            let mensaje = '';
            if (error.response === undefined) {
                mensaje = 'Error de Conexion'
            } else {
                if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
                    mensaje = 'Ya existe un Registro'
                }
                else {
                    mensaje = error.response.data.message
                }
            }
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
            setActivate(false);
        })
    };

    const handleCloseSi = () => {
        setActivate(false);
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
        procesarRegistro();
    };

    const seleccionarRegistros = () => {
        let endpoint = `${op.conexion}/api/administracion/catalogoreten`;
        setActivate(true);
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {
            if (response.status === 200) {
                setRecords(response.data)
            }
            setActivate(false);
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' })
            setActivate(false);
        })

    }
    useEffect(() => {
        seleccionarRegistros()
    }, []);

    const cerrar = () => {
        props.setTabla(0)
    }

    const gestionarBanco = (op, id, per) => (e) => {
        e.preventDefault();
        if (per.toString() === '1') {
            setOperacion(op)
            console.log(op)
            if (op === 1) {
                setMostrar(true)
            } else {
                setIdReten(id);
                setMostrar(true)

            }
        } else {
            setToast({
                mostrar: true,
                mensaje: op === 1 ? 'No posee permiso para Registrar' : op === 2 ? 'No posee permiso para Editar' : op === 3 ? 'No posee permiso para Eliminar' : 'No posee permiso para Consultar',
                titulo: 'Alerta.'
            })
        }
    }
    return (
        <section  className='col-7 m-0 p-0 mx-auto mt-5'>
            <header className='col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top text-light azulGradiant'>
                <h3 className='m-0'>
                    {tituloHeader}
                </h3>
                <a type='button' 
                    onClick={cerrar}>
                    salir<i className="fa fa-times ms-2"></i>
                </a>
            </header>
            <form onSubmit={(e)=>{e.preventDefault()}} 
                className='col-12 m-0 p-2 d-flex justify-content-between'>
                <div className='col-4 m-0 p-0'>
                    <input 
                        ref={txtBuscador} 
                        onChange={handleSearch} 
                        placeholder="Buscar"  className='search-input form-control form-control-sm'/>
                </div>
                <PrimaryButton icon = 'fa-plus m-0'
                    disabled={!permiso.toString().substring(1, 2) === '1'}
                    onClick={gestionarBanco(1, '', permiso.toString().substring(1, 2))} 
                    title='Agregar Contribuyente' 
                >
                </PrimaryButton>
            </form>
            <div className="table-azulGradiant">
                <TblContainer>
                    <TblHead />
                    <tbody>
                        {
                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                <tr key={index} style={{ padding: "0" }}>
                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>{item.idtiporetencion}</td>
                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '300px' }}>{item.descripcion}</td>
                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '60px' }}>
                                        <button onClick={gestionarBanco(4, item.idtiporetencion, permiso.toString().substring(0, 1))} className={permiso.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-info rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fas fa-eye"></i> </button>
                                        <a> &nbsp; </a>
                                        <button onClick={gestionarBanco(2, item.idtiporetencion, permiso.toString().substring(2, 3))} className={permiso.toString().substring(2, 3) === '1' ? 'btn btn-sm btn-warning rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fa fa-edit"></i> </button>
                                        <a> &nbsp; </a>
                                        <button onClick={gestionarBanco(3, item.idtiporetencion, permiso.toString().substring(3, 4))} className={permiso.toString().substring(3, 4) === '1' ? 'btn btn-sm btn-danger rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fa fa-trash-alt"></i> </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>
            <ModalRetenciones
                show={mostrar}
                onHideCancela={() => { setMostrar(false) }}
                idReten={idReten}
                operacion={operacion}
                onHideRenderizar={seleccionarRegistros}
            />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast}
            />
        </section>
    );
}
export default TablaTipoRetenciones;